import React, { Component } from 'react';
import AdminLayout from 'components/layout/AdminLayout';
import Header from 'components/layout/Partials/Header';
import { getDynamicApp } from 'redux/actions/dagActions';
import { Theme } from 'utils/Theme';
import Loading from 'components/common/Loading';
import { Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { connect } from 'react-redux';
import * as Icon from 'react-feather';
import DataTable from 'react-data-table-component';
import Section from 'components/UI/Section';

const styles = Theme();

class ViewDynamicApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicApp: null,
            loading: true,
        };
    }

    componentDidMount() {
        this.props.getDynamicApp(this.props.match.params.id);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let { loading, dynamicApp } = prevState;
        if (
            nextProps.dag.dynamicApp !== dynamicApp &&
            nextProps.dag.dynamicApp
        ) {
            dynamicApp = nextProps.dag.dynamicApp;
            loading = nextProps.dag.loading;
        }
        return { dynamicApp, loading };
    }

    render() {
        const { dynamicApp, loading } = this.state;

        if (loading) {
            return <Loading />;
        }

        const { classes } = this.props;
        return (
            <AdminLayout>
                <Header>
                    <h2 className="c-navbar__title">Dynamic App</h2>
                </Header>
                <div className="u-p-xsmall">
                    <Section>
                        <div className={'row'}>
                            <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                                <div className="u-m-auto">
                                    <div className="c-card u-p-zero u-m-zero u-pb-medium">
                                        <div className="o-line c-card__title u-p-small u-m-small">
                                            <h4
                                                className={`c-card__title ${classes.colorSecondary}`}
                                            >
                                                {dynamicApp.title}
                                            </h4>
                                            <div className="c-dropdown dropdown">
                                                <span
                                                    className={`c-btn ${classes.buttonPrimary} has-icon dropdown-toggle`}
                                                    id="MoreActionsDropdown"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                >
                                                    More Actions
                                                </span>

                                                <div
                                                    className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                                                    aria-labelledby="MoreActionsDropdown"
                                                >
                                                    <div
                                                        onClick={() => {
                                                            this.props.history.goBack();
                                                        }}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        Back
                                                    </div>
                                                    <Link
                                                        to={`/settings/pages`}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        Pages
                                                    </Link>
                                                    <Link
                                                        to={`/settings/dag/filters`}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        Filters
                                                    </Link>
                                                    <Link
                                                        to={`/settings/dag/master-apps`}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        Master Apps
                                                    </Link>
                                                    <Link
                                                        to={`/settings/dag/dynamic-apps`}
                                                        className="c-dropdown__item dropdown-item"
                                                    >
                                                        Dynamic Apps
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={'row u-p-small'}>
                                            <div className="col-md-6 u-m-auto">
                                                <div className="c-state-card c-state-card--default">
                                                    <h4 className="c-state-card__title">
                                                        Users
                                                    </h4>
                                                    <span className="c-state-card__number">
                                                        {
                                                            dynamicApp.users
                                                                .length
                                                        }
                                                    </span>
                                                    <p className="c-state-card__status">
                                                        <i className="feather icon-users"></i>{' '}
                                                        Dynamic App Linked Users
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="col-md-6 u-m-auto">
                                                <div className="c-state-card c-state-card--default">
                                                    <h4 className="c-state-card__title">
                                                        Filter Values
                                                    </h4>
                                                    <span className="c-state-card__number">
                                                        {
                                                            dynamicApp
                                                                .filterValues
                                                                .length
                                                        }
                                                    </span>
                                                    <p className="c-state-card__status">
                                                        <i className="feather icon-users"></i>{' '}
                                                        Dynamic App data filter
                                                        values
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={'col-md-12 u-m-auto '}>
                                            <div className="c-card">
                                                <span className="c-text--subtitle">
                                                    App Name
                                                </span>
                                                <p className="u-mb-small u-text-large">
                                                    {dynamicApp.title}
                                                </p>

                                                <span className="c-text--subtitle">
                                                    Qlik Sense App ID
                                                </span>
                                                <p className="u-mb-small u-text-large">
                                                    {dynamicApp.qsApp}
                                                </p>

                                                <span className="c-text--subtitle">
                                                    Reload Task ID
                                                </span>
                                                <p className="u-mb-small u-text-large">
                                                    {dynamicApp.reloadTask}
                                                </p>

                                                <span className="c-text--subtitle u-block">
                                                    Actions
                                                </span>
                                                <div
                                                    className={
                                                        'u-mt-small u-mb-medium'
                                                    }
                                                >
                                                    <NavLink
                                                        className={`c-btn ${classes.buttonPrimary}`}
                                                        to={`/settings/dag/master-apps/${dynamicApp.masterApp._id}/view`}
                                                    >
                                                        View Master App
                                                    </NavLink>
                                                </div>

                                                <span className="c-text--subtitle u-block">
                                                    Filter Values
                                                </span>
                                                <div className={' u-mt-small'}>
                                                    <div
                                                        className={
                                                            'c-table-responsive'
                                                        }
                                                    >
                                                        <DataTable
                                                            columns={[
                                                                {
                                                                    name:
                                                                        'Title',
                                                                    selector:
                                                                        'title',
                                                                },
                                                                {
                                                                    name:
                                                                        'Description',
                                                                    selector:
                                                                        'description',
                                                                },
                                                                {
                                                                    name:
                                                                        'Actions',
                                                                    cell: (
                                                                        row
                                                                    ) => (
                                                                        <NavLink
                                                                            className={`c-btn c-btn--small ${classes.buttonPrimary}`}
                                                                            to={`/settings/dag/filter-values/${row._id}/view`}
                                                                        >
                                                                            <Icon.Eye
                                                                                size={
                                                                                    10
                                                                                }
                                                                            />{' '}
                                                                            View
                                                                        </NavLink>
                                                                    ),
                                                                },
                                                            ]}
                                                            data={
                                                                dynamicApp.filterValues
                                                            }
                                                            className={
                                                                'c-table'
                                                            }
                                                            noHeader
                                                        />
                                                    </div>
                                                </div>

                                                <span className="u-mt-medium c-text--subtitle u-block">
                                                    Dynamic App Users{' '}
                                                </span>
                                                <div className={'u-mt-small'}>
                                                    <div
                                                        className={
                                                            'c-table-responsive'
                                                        }
                                                    >
                                                        <DataTable
                                                            columns={[
                                                                {
                                                                    name:
                                                                        'Name',
                                                                    selector:
                                                                        'name',
                                                                },
                                                                {
                                                                    name:
                                                                        'Email',
                                                                    selector:
                                                                        'email',
                                                                },
                                                                {
                                                                    name:
                                                                        'Actions',
                                                                    cell: (
                                                                        row
                                                                    ) => (
                                                                        <NavLink
                                                                            className={`c-btn c-btn--small ${classes.buttonPrimary}`}
                                                                            to={`/settings/users/view/${row._id}`}
                                                                        >
                                                                            <Icon.Eye
                                                                                size={
                                                                                    10
                                                                                }
                                                                            />{' '}
                                                                            View
                                                                        </NavLink>
                                                                    ),
                                                                },
                                                            ]}
                                                            data={
                                                                dynamicApp.users
                                                            }
                                                            className={
                                                                'c-table'
                                                            }
                                                            noHeader
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Section>
                </div>
            </AdminLayout>
        );
    }
}

ViewDynamicApp.propTypes = {
    dag: PropTypes.object.isRequired,
    getDynamicApp: PropTypes.func.isRequired,
    classes: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
};

const map_state_to_props = (state) => ({
    dag: state.dag,
});

export default connect(map_state_to_props, { getDynamicApp })(
    withStyles(styles)(ViewDynamicApp)
);
